import React from 'react';


import {
    Cards,
    CardsPropertyFiltering,
    Button,
    CardsPagination, Spinner,
    Tabs
} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from '../common';

const cardDefinition = {
    // header: item => item.name,
    sections: [
        {
            id: "name",
            width: 50,
            header: item => "Description",
            content: item => item.name
        },
        {
            id: "period",
            width: 50,
            header: item => "Period",
            content: item => item.period
        },
        {
            id: "user",
            width: 50,
            header: "User",
            content: item => item.user
        },
        {
            id: "uuid",
            width: 50,
            header: "ID",
            content: item => <a href={`#/searches/${item.uuid}`}>{item.uuid}</a>
        },
        {
            id: "link",
            width: 50,
            header: "Search Link",
            content: item => <a href={item.search_link} target={"_blank"}>Search Link</a>
        },
        {
            id: "schedule",
            width: 50,
            header: "Schedule",
            content: item => <Button text="Now" onClick={handleClick.bind(this,item)} variant="primary"></Button>
        }
    ]
};

const cardsPerRow = [
    {
        "cards": 1
    },
    {
        "minWidth": 500,
        "cards": 2
    }
];
const handleClick= (item,e)=>{
    console.log(item, e);
    //push sql query to SQS;

}

export class SearchCard extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            unknownloaderror: false,
            initialLoadDone: false,
            user: "",
            searchLoadDone: false,
            searches: []
        };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getSearchesResultHandler = this.getSearchesResultHandler.bind(this);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
            this.client.getSearches({
                type: this.state.type,
                user: this.state.user, ...this.props
            }, this.getSearchesResultHandler);
        });
    }

    componentWillMount() {
        this.client = new JSClient({onReady: this.clientLoaded});
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if (!objectCompare(this.state.props, nextProps)) {
    //         this.setState({...this.state, props: JSON.parse(JSON.stringify(nextProps)), taskLoadDone: false});
    //     }
    // }
    //
    // componentWillUpdate(nextProps, nextState, nextContext) {
    //     if (!nextState.taskLoadDone)
    //         this.client.getTasks({
    //             type: nextState.type,
    //             user: nextState.user, ...nextProps
    //         }, this.getTasksResultHandler);
    // }

    getSearchesResultHandler(searchResult) {
        this.setState({searches: searchResult.searches, searchLoadDone: true});
    }

    headerCounter(items) {
        return items.length;
    }

    render() {
        if (!this.state.initialLoadDone) {
            return (<div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'><Spinner/></div>)
        }
        return (
            <div>

                <div>

                        <Cards
                            cardDefinition={cardDefinition}
                            items={this.state.searches}
                            cardsPerRow={cardsPerRow}
                            loadingText="Loading resources"
                            wrapLines={false}
                            header={<h2>
                                Filter Searches
                            </h2>}
                            empty={<div className="awsui-util-t-c">
                                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                    <b>
                                        No resources
                                    </b>
                                </div>
                                <p className="awsui-util-mb-s">
                                    No resources to display
                                </p>
                                <div className="awsui-util-mb-m">
                                    <Button text="Create resource"></Button>
                                </div>
                            </div>}
                            noMatch={<div className="awsui-util-t-c">
                                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                    <b>
                                        No matches
                                    </b>
                                </div>
                                <p className="awsui-util-mb-s">
                                    We can’t find a match.
                                </p>
                                <div className="awsui-util-mb-m">
                                    <Button text="Clear filter"></Button>
                                </div>
                            </div>}
                        >
                            <CardsPagination pageSize={10}></CardsPagination>
                            <CardsPropertyFiltering
                                filteringOptions={[
                                    {
                                        groupValuesLabel: 'Period Values',
                                        propertyKey: 'period',
                                        propertyLabel: 'Period',
                                        values: ['1', '2']
                                    },
                                    {
                                        groupValuesLabel: 'Name Values',
                                        propertyKey: 'name',
                                        propertyLabel: 'Name',
                                        values: []
                                    }
                                ]}
                                groupValuesText="Values"
                                groupPropertiesText="Properties"
                                operationAndText="and"
                                operationNotAndText="and not"
                                operationOrText="or"
                                operationNotOrText="or not"
                                clearFiltersText="Clear filter"
                                allowFreeTextFiltering={true}
                                filteringCountTextFunction={count => `${count} ${count === 1 ? 'match' : 'matches'}`}
                            />
                        </Cards>
                </div>
            </div>


        );
    }
}




// WEBPACK FOOTER //
// ./src/components/cards/search_card.jsx